import { ADMINURL } from "helpers/constant";
import { callApi } from "Apis";
import { encryptId } from "helpers/cryptography";
import { PLAIN_TEXT } from "helpers/constant";

// Member List Api...
export async function memberList(data) {
  try {
    const response = await callApi({ url: ADMINURL.MEMBER_LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Unverified Member List Api...
export async function unverifiedMemberList(data) {
  try {
    const response = await callApi({
      url: ADMINURL.UNVERIFIED_MEMBERS,
      body: data,
      method: "POST",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Sub Member List Api...
export async function subMemberList(data) {
  try {
    const response = await callApi({ url: ADMINURL.SUB_MEMBER_LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Member Add Api...
export async function addMember(data) {
  try {
    const response = await callApi({ url: ADMINURL.MEMBER_ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
//Get Member By ID...
export async function getMember(id) {
  try {
    const response = await callApi({ url: ADMINURL.MEMBER_GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
//Update Member Api...

export async function updateMember(data) {
  try {
    const response = await callApi({ url: ADMINURL.MEMBER_UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Member Delete Api...
export async function deleteMember(id) {
  try {
    const response = await callApi({
      url: ADMINURL.MEMBER_DELETE(id),
      method: "DELETE",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// District List Api...
export async function districtsListApi(data) {
  try {
    const response = await callApi({ url: "district/list", body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Taluka List Api...
export async function talukasListApi(data) {
  try {
    const response = await callApi({ url: "taluka/list", body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Village List Api...
export async function villagesListApi(data) {
  try {
    const response = await callApi({ url: "village/list", body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// education List Api...
export async function educationListApi(data) {
  try {
    const response = await callApi({ url: "education/list", body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// occupation List Api...
export async function occupationListApi(data) {
  try {
    const response = await callApi({ url: "occupation/list", body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Member Verify Api...
export async function verifyMember(id) {
  try {
    const encryptedId = PLAIN_TEXT ? id : encryptId(id);
    const response = await callApi({
      url: ADMINURL.MEMBER_VERIFY(encryptedId),
      method: "PUT",
    });
    return response;
  } catch (err) {
    throw err;
  }
}

// Member reset phone view limit Api...
export async function resetMemberPhoneNumberViewLimit(id) {
  try {
    const encryptedId = PLAIN_TEXT ? id : encryptId(id);
    const response = await callApi({
      url: ADMINURL.MEMBER_PHONE_VIEW_LIMIT_RESET(encryptedId),
      method: "PUT",
    });
    return response;
  } catch (err) {
    throw err;
  }
}
